
import { useLiveQuery } from "dexie-react-hooks";
import db from "../db";
import nl2br from "./utils/nl2br";

function Translate({ pacchetto, ...props }) {

    const pacchetti = useLiveQuery(() => db.pacchetti.where({ nome: pacchetto }).toArray());

    //qui lang deve esistere (ci pensa la bar a impostarla)
    if (pacchetti === undefined) {
        return null;
    }
    return (
        <Translate0
            pacchetto={pacchetti.length === 0 ? null : pacchetti[0]}
            {...props}
        />
    );
}
function Translate0({ chiave, pacchetto }) {


    const traduzione = useLiveQuery(() => db.traduzioni.where({ chiave, pacchettoId: pacchetto?.id || -1 }).first());


    const v = traduzione?.valore || null;
    if (!v || v.indexOf('\n') === -1) {
        return v;
    }
    return nl2br(v);
}

export default Translate